import { User } from './user';

export class UserStatusCommand {
    status: string;

    constructor(user: User) {
        this.status = user.status;
    }
}
